export const MobileUiVars = {
  bottomBarHeight: 50,
  mobileBp: 991,
};
